import tmhRequest from '@/config/tmhRequest'

export default {
    searchMyCardReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycardreport/searchmycardreportcount',
            method: 'post',
            data: data,
        })
    },
    searchMyCardReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycardreport/searchmycardreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMyCardReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycardreport/exportmycardreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/mycardreport.js